module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	
	fox.registerWidget('SocialNetwork_Manager', {
		
		configure: function(options) {
			this.appName = null;

			this.registerOptions('', {
				autoRender: true,

				'widgets': {
					dl: {
						widget: 'Datalayer',
						method: 'SocialNetwork.getList'
					},

					disconnectApi: {
						widget: 'Api',
						method: 'SocialNetwork.disconnect'
					}
				},

				'handleWom.disconnectApiHandle': {
					widget: '#disconnectApi',
					event: 'success',
					callback: function(response) {
						fox.wom.selectFirst('@root').dispatchEvent('successOauthDisconnect');
						this.dl.load();
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.dl.setTransitParameter('mode', this.getOption('mode'));
			this.callParent('running', arguments);
		},

		activate: function () {
			this.dl.setTransitParameter('mode', this.getOption('mode'));
			this.dl.load();
			this.callParent('activate', arguments);
		},

		socialClickHandler: function(elt) {
			var requestUrl = elt.getAttribute('data-request-url');
			var appName = elt.getAttribute('data-app-name');
			var root = fox.wom.selectFirst('@root');


			if (!fox.isEmpty(requestUrl)) {
				var popupWidth = 800;
				var popupHeight = 900;				
				var popupOptions = 'left=' + (window.screenX + (window.outerWidth - popupWidth) / 2) + ','
					+ 'top=' + (window.screenY + (window.outerHeight - popupHeight) / 2) + ','
					+ 'width=' + popupWidth + ','
					+ 'height=' + popupHeight + ','
					+ 'toolbar=0,scrollbars=1,status=1,resizable=1,location=1,menuBar=0'
				;

				var oauthPopup = window.open(requestUrl, 'oauthPopup', popupOptions);
				var dl = this.dl;
				var widgetOauth = this;

				this.appName = appName;

				this.window.addEventListener('message', function(event) {
					if (fox.isSet(event.data.oauthConnected)) { // oauth event
						if (event.data.oauthConnected === 0) {
							widgetOauth.dispatchEvent('failOauth', event.data);
							root.dispatchEvent('failOauth', event.data);
						}

						if (fox.isSet(event.data.error)) {
							widgetOauth.dispatchEvent('errorIn2FaLogin', event.data);
							event.source.close();

							return;
						}

						if (widgetOauth.getOption('mode') === 'signup') {
							widgetOauth.dispatchEvent('recieveProfile', event.data);
							root.dispatchEvent('recieveProfile', event.data);
						} else if (widgetOauth.getOption('mode') === 'settings'){
							widgetOauth.dispatchEvent('successOauth', event.data);
							root.dispatchEvent('successOauth', event.data);
						} else {
							if (fox.isEmpty(event.data.userInfo)) {
								widgetOauth.dispatchEvent('successLogin', event.data);
							} else { 
								if (!fox.isEmpty(event.data.twoFactorAuth)) {
									widgetOauth.dispatchEvent('readyFor2FaLogin', event.data);
								} else {
									// user have not signed up
									widgetOauth.dispatchEvent('readyForReg', event.data);
								}
							}
						}

						event.source.close();
					}
				});

				if (oauthPopup) {
					oauthPopup.focus();
				}
			} else {
				this.appName = null;

				this.rwom1('#disconnectApi').send({
					alias: elt.getAttribute('data-app-name')
				});
			}
		}

	}, 'Grid');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/socialNetwork/manager.js
// module id = 359
// module chunks = 2